<template>
  <div class="panel-browser">
    <div class="left">
      <nav class="panel">
        <div class="top">
          <slot name="heading"></slot>
          <div v-if="searchEnabled" class="panel-block">
            <p class="control has-icons-left">
              <input v-model="searchText" class="input is-small" type="text" placeholder="search">
              <span class="icon is-small is-left">
                <i class="fas fa-search" aria-hidden="true"></i>
              </span>
            </p>
          </div>
          <p v-if="tabsEnabled" class="panel-tabs">
            <slot name="filter-tabs"></slot>
          </p>
        </div>
        <div class="bottom">
          <slot></slot>
        </div>
      </nav>
    </div>
   <div class="right">
     <slot name="right"></slot>
   </div>
  </div>
</template>

<script>
export default {
  name: 'PanelBrowser',
  props: {
    title: {
      type: String,
      required: true,
    },
    search: {
      type: String,
      default: '',
    },
    searchEnabled: {
      type: Boolean,
      default: true,
    },
    tabsEnabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      filter: null,
      searchText: this.search,
    };
  },
  watch: {
    searchText() {
      this.$emit('update:search', this.searchText);
    },
  },
  methods: { },
  computed: { },
};
</script>

<style lang="scss" scoped>

.panel-browser {
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0; // Needed for firefox to enable scrolling

  .left {
    flex: 0;
    background: $main-background;
    border-right: 1px solid $border-color;
    display: flex;
  }

  .right {
    flex: 1;
    display: flex;
    min-width: 0; // This is needed to force line wrapping in the TextEditor component
  }

  nav.panel {
    flex-grow: 1;
    width: $docs-nav-panel-width;
    border: 0;

    display: flex;
    flex-direction: column;

    font-size: .9rem;

    .top {
      flex: 0;
    }

    .bottom {
      overflow-y: auto;
      flex: 1;
    }

    .selected, .panel-item:hover {
      background-color: $form-subitem;
    }

    .panel-item {
      padding: .5rem 0;
      border-bottom: 1px solid;
      cursor: pointer;

      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .panel-heading, .panel-block, .panel-tabs, .panel-list {
      border-bottom: 1px solid $border-color;
      border-left: 0;
      border-right: 0;
      border-top: 0;
    }

    .panel-heading, .panel-block {
      height: $navbar-height;
    }

    p.panel-heading {
      text-align: center;
      background-color: $main-background;
      color: $font-color;
      border-radius: 0;
    }

    .panel-block {
      img {
        height: 25px;
        width: 25px;
      }
    }
  }
}

</style>
